import { AppModule } from 'app/module';
import './styles.scss';

export class ArticleCard extends AppModule {
}
